// extracted by mini-css-extract-plugin
export default {"CtaPill":"CtaPill_CtaPill__vwbJu","Blue":"CtaPill_Blue__QCy7w","Disabled":"CtaPill_Disabled__qH3Or","Icon":"CtaPill_Icon__poIi0","Spinner":"CtaPill_Spinner__-mf4l"};